@if (enableAll() && (chips()?.length === 0 || chips()?.length === totalCount())) {
  <mat-chip [class]="class()">
    {{ allText() | translate }}
  </mat-chip>
} @else {
  @for (chip of chips(); track chip) {
    @if (chip.removable) {
      <mat-chip (removed)="removeChip(chip?.type)" [class]="chip?.class ? chip.class : 'default-chip selected-chip'">{{ chip?.name | translate }}
        <button matChipRemove>
          <mat-icon class="remove-filter-icon">cancel</mat-icon>
        </button>
      </mat-chip>
    } @else {
      <mat-chip [class]="chip?.class">{{ chip?.name | translate }}
      </mat-chip>
    }
  }
}

@if (standAlone()) {
  <mat-chip [class]="class()">{{ name() }}</mat-chip>
}
